import { useTranslation } from 'react-i18next';

import TextField from 'components/shared/ControlledFields/ControlledTextField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

const BaseClusterSection = ({ control }) => {
  const { t } = useTranslation('common');

  return (
    <MultiStepForm.Section
      title={t('adminPortal.baseSelection')}
      validateFields={['code', 'name', 'description']}
    >
      <TextField
        name="code"
        control={control}
        label={t('code')}
        variant="outlined"
      />
      <TextField
        name="name"
        control={control}
        variant="outlined"
        label={t('name')}
      />
      <TextField
        name="description"
        control={control}
        variant="outlined"
        label={t('description')}
      />
    </MultiStepForm.Section>
  );
};

export default BaseClusterSection;
